/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiSystemDetails } from '../../models/api-system-details';

export interface ApiSystemHistorySystemSerialNumberSystemMaterialNumberTicketNumberGet$Params {
  systemSerialNumber: string;
  systemMaterialNumber: number;
  ticketNumber: string;
}

export function apiSystemHistorySystemSerialNumberSystemMaterialNumberTicketNumberGet(http: HttpClient, rootUrl: string, params: ApiSystemHistorySystemSerialNumberSystemMaterialNumberTicketNumberGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiSystemDetails>> {
  const rb = new RequestBuilder(rootUrl, apiSystemHistorySystemSerialNumberSystemMaterialNumberTicketNumberGet.PATH, 'get');
  if (params) {
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
    rb.path('ticketNumber', params.ticketNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiSystemDetails>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
apiSystemHistorySystemSerialNumberSystemMaterialNumberTicketNumberGet.PATH = '/api/SystemHistory/{systemSerialNumber}/{systemMaterialNumber}/{ticketNumber}';
apiSystemHistorySystemSerialNumberSystemMaterialNumberTicketNumberGet.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
apiSystemHistorySystemSerialNumberSystemMaterialNumberTicketNumberGet.ROOTURL = '/tube';
